import PropTypes from 'prop-types';
import React from 'react';
import CompareStocks from '../CompareStocks/CompareStocks';
import Container from '../Container/Container';
import PriceChart from '../PriceChart/PriceChart';
import StockHeader from '../StockHeader/StockHeader';
import EarningsCall from '../EarningsCall/EarningsCall';
import style from './StockPage.module.css';
import About from '../About/About';
import ESGScore from '../ESGScore/ESGScore';
import RevenueSources from '../RevenueSources/RevenueSources';
import ShareStatistics from '../ShareStatistics/ShareStatistics';
import ValuationAndMultiples from '../ValuationAndMultiples/ValuationAndMultiples';
import Return from '../Return/Return';
import AnalystOneYearPriceTarget from '../AnalystOneYearPriceTarget/AnalystOneYearPriceTarget';
import CurrentFairValue from '../CurrentFairValue/CurrentFairValue';
import StockDetails from '../StockDetails/StockDetails';
import InsiderTrades from '../InsiderTrades/InsiderTrades';
import News from '../News/News';

const StockPage = (props) => {
  return (
    <div className={style.pageContainer}>
      <StockHeader stock={props.stock} />

      <Container>
        <PriceChart stock={props.stock} />

        <div className={style.flexGrid}>
          <CompareStocks stock={props.stock} metricPercentiles={props.metric_percentiles} />
        </div>

        <div className={`${style.flexGrid} ${style.boxes}`}>
          <EarningsCall earnings_call_transcript={props.earnings_call_transcript} stock={props.stock} current_user={props.current_user} />
          <News stock={props.stock} />
        </div>

        <div className={`${style.flexGrid} ${style.boxes}`}>
          <AnalystOneYearPriceTarget stock={props.stock} price_target_summary={props.price_target_summary} price={props.price} />
          <CurrentFairValue discounted_cash_flows={props.discounted_cash_flows} price_target={props.price_target} price={props.price} />
        </div>

        <StockDetails stock={props.stock} />

        <div className={style.flexGrid}>
          <div>
            <ShareStatistics share_statistics={props.share_statistics} />
            <Return stock={props.stock} price={props.price} />
          </div>
          <ValuationAndMultiples valuation={props.valuation} />
        </div>

        <div className={style.flexGrid}>
          <RevenueSources stock={props.stock} />
          <InsiderTrades stock={props.stock} current_user={props.current_user} />
        </div>

        <div className={style.flexGrid}>
          <ESGScore stock={props.stock} />
          <About about={props.about} />
        </div>
      </Container>


    </div>
  );
};

// this is passed from the Rails view
StockPage.propTypes = {
  stock: PropTypes.object.isRequired,
  metric_percentiles: PropTypes.array.isRequired,
  earnings_call_transcript: PropTypes.object,
};

export default StockPage;
